<template>
  <div
    :class="
      'size-full left-0 bottom-0 absolute z-1' +
      (background ? ' bg-dark-1/10' : '')
    "
  >
    <div :class="classes"></div>
  </div>
</template>
<script>
export default {
  props: {
    background: {
      type: Boolean,
    },
    top: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      let classes = "loader absolute left-1/2 -translate-x-1/2 size-[100px]";
      if (this.top) {
        classes += " top-24";
      } else {
        classes += " top-1/2 -translate-y-1/2";
      }
      return classes;
    },
  },
};
</script>
